import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { Account } from './accounts.types';

const accountsApiPath = '/accounts';

export type GetAccounts = () => Promise<AxiosResponse<Account[] & ApiError>>;

export const getAccounts: GetAccounts = async () => {
  return instance.get(accountsApiPath).catch(e => e.response as never);
};

export const createAccount = async ({
  data,
}: {
  data: { username: string };
}): Promise<AxiosResponse<Account & ApiError>> => {
  return instance.post<Account>(accountsApiPath, data).catch(e => e.response as AxiosError<ApiError> as never);
};

const accountApiPath = (id: number) => `/accounts/${id}`;

export const updateAccount = async (data: Account): Promise<AxiosResponse<Account & ApiError>> => {
  return instance.post<Account>(accountApiPath(data.id), data).catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteAccount = async ({ id }: { id: number }): Promise<AxiosResponse<Account & ApiError>> => {
  return instance.delete<Account>(accountApiPath(id)).catch(e => e.response as AxiosError<ApiError> as never);
};
